export const endpoints = {
  // access: '/file/fileDetails',
  access: '/getDataByPoAndSscc',
  fileUrl: '/getUrlByPoAndSscc',
  saveData: '/savedata',
}
